import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "./AlumniSliderNew.css";
import AlumniImg1 from "../../assets/ALumni_sliderImgs/AluminiDashnoard1.jpg";
import AlumniImg2 from "../../assets/ALumni_sliderImgs/Aluminidashboard2.jpg";
import ALumniImg3 from "../../assets/ALumni_sliderImgs/Alumnidashboard3.jpg";
import AlumniImg4 from "../../assets/ALumni_sliderImgs/AlumniDashboard4.jpg";
import AlumniImg5 from "../../assets/ALumni_sliderImgs/ALumniDashboard5.jpg";
import AlumniImg6 from "../../assets/ALumni_sliderImgs/AluminiDashboard6.jpg";
import './Alumnislider.css'

const AlumniSlider = () => {
  return (
    <div className="alumni-slider">
      <form>
        <fieldset className="alumni-slider__fieldset">
          <legend className="alumni-slider__legend">Alumni Interface</legend>

          <button
            className="alumni-slider__nav-button alumni-slider__nav-button--prev swiper-button-prev"
            id="alumini_prevBtn"
          ></button>
          <button
            className="alumni-slider__nav-button alumni-slider__nav-button--next swiper-button-next"
          ></button>

          <Swiper
            modules={[Navigation, Pagination, Autoplay]}
            pagination={{ clickable: true }}
            autoplay={{ delay: 3000 }}
            spaceBetween={20}
            slidesPerView={1}
            loop={true}
            navigation={{
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            }}
          >
            {[AlumniImg1, AlumniImg2, ALumniImg3, AlumniImg4, AlumniImg5, AlumniImg6].map(
              (image, index) => (
                <SwiperSlide key={index}>
                  <div className="alumni-slider__slide">
                    {/* <h4 className="alumni-slider__title">Slide {index + 1}</h4> */}
                    <img
                      className="alumni-slider__image"
                      src={image}
                      alt={`Slide ${index + 1}`}
                    />
                  </div>
                </SwiperSlide>
              )
            )}
          </Swiper>
        </fieldset>
      </form>
    </div>
  );
};

export default AlumniSlider;
